/*
 * ForgeBridge — tiny postMessage bridge to the embedding 4E Concept Forge parent.
 * Lets Forge enable its "To Viewport" button the moment animations are checked, and
 * trigger a bridge-only export (no file download) on demand — so the user never has to
 * press Mesh2Motion's own Export button + dismiss a dialog to get the model into Forge.
 */
function parent_target (): Window | null {
  return (window.parent !== window) ? window.parent : window.opener
}

export const ForgeBridge = {
  /** Tell Forge how many animation clips are currently checked. */
  post_selection (count: number): void {
    try {
      const t = parent_target()
      if (t != null) t.postMessage({ type: '4e-m2m-selection', count }, '*')
    } catch (e) { /* not embedded — ignore */ }
  },

  /** Run `cb` when Forge asks us to export the checked clips straight to its viewport. */
  on_send_to_viewport (cb: () => void): void {
    window.addEventListener('message', (e: MessageEvent) => {
      const d: any = e.data
      if (d != null && d.type === '4e-forge-send-to-viewport') cb()
    })
  }
}
